module.exports = __webpack_public_path__ + "static/media/first-enrollment-banner.409aa950.png";